// Auth utility functions

const OPS_ROLES = ['agent', 'foc', 'technician', 'super_admin'];

export const setLastPortal = (portal) => {
  localStorage.setItem('last_portal', portal); // 'ops' | 'customer'
};

export const getLastPortal = () => {
  return localStorage.getItem('last_portal') || 'customer';
};

export const setAuthToken = (token) => {
  localStorage.setItem('auth_token', token);
};

export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

export const removeAuthToken = () => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user');
  // Note: intentionally keep 'last_portal' so redirect after logout goes to correct login
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};

export const hasRole = (role) => {
  const user = getUser();
  return user?.role === role;
};

export const getUserRole = () => {
  const user = getUser();
  return user?.role;
};

export const logout = () => {
  const portal = getLastPortal();
  removeAuthToken();
  window.location.href = portal === 'ops' ? '/ops/login' : '/login';
};